import { useEffect } from "react";

/**
 * Installs the storefront's offline shell on real HTTPS deployments.
 * Browsers correctly refuse service workers behind an untrusted certificate;
 * that failure is reported once and leaves the normal online app untouched.
 */
export default function ServiceWorkerBridge() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    // The build id in the URL gives every deployment its own worker and its own
    // caches, so a new build replaces the previous offline copy instead of
    // inheriting a saved shell that points at deleted script files.
    const build = (window as unknown as { __NEXT_DATA__?: { buildId?: string } }).__NEXT_DATA__?.buildId ?? "v1";
    void navigator.serviceWorker.register(`/service-worker.js?v=${encodeURIComponent(build)}`, { scope: "/" }).catch((error) => {
      // eslint-disable-next-line no-console
      console.warn("[offline] service worker registration failed:", error);
    });
  }, []);
  return null;
}
